import { render, staticRenderFns } from "./Penalidades.vue?vue&type=template&id=3c1a5f8f"
import script from "./Penalidades.vue?vue&type=script&lang=js"
export * from "./Penalidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports